import { useCreateSection } from './useCreateSection';
import { CreateFreeElementTool } from '../canvas-element-tool/CreateFreeElementTool';
import { useCanvasFreeElementContext } from '../canvas-element-tool/CanvasFreeElementContext';
import { useCallback } from 'react';

export const CreateSectionTool = () => {
  const { createSection } = useCreateSection();
  const { setCreateElementActive } = useCanvasFreeElementContext();

  const setCreateSectionActive = useCallback(
    (active: boolean) => setCreateElementActive(active ? 'section' : null),
    [setCreateElementActive],
  );

  return (
    <CreateFreeElementTool
      onCreate={createSection}
      onCancel={() => setCreateSectionActive(false)}
    />
  );
};
